
namespace GeniuzPOS.Purchase {

    @Serenity.Decorators.registerClass()
    export class PoApprovalTranGrid extends Serenity.EntityGrid<PoApprovalTranRow, any> {
        protected getColumnsKey() { return PoApprovalTranColumns.columnsKey; }
        protected getDialogType() { return PoApprovalTranDialog; }
        protected getIdProperty() { return PoApprovalTranRow.idProperty; }
        protected getInsertPermission() { return PoApprovalTranRow.insertPermission; }
        protected getLocalTextPrefix() { return PoApprovalTranRow.localTextPrefix; }
        protected getService() { return PoApprovalTranService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        
    }
}